"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversationInitialize = exports.conversationSend = exports.processQueue = exports.conversationQueueShift = exports.conversationQueueClear = exports.conversationQueueAppend = exports.conversationProcessingSet = exports.conversationSet = exports.conversationRemoveLast = exports.conversationClear = exports.conversationAppend = void 0;

var _ChatbotsApi = _interopRequireDefault(require("../../clients/ChatbotsApi"));

var _LiveEngage = _interopRequireDefault(require("../../clients/LiveEngage"));

var _conversation = require("../selectors/conversation");

var _app = require("./app");

var _traffic = require("./traffic");

var _types = require("../types");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var wait = function wait(milliseconds) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, milliseconds);
  });
};

var conversationAppend = function conversationAppend(newMessage) {
  return function (dispatch, getState) {
    var conversation = (0, _conversation.getConversation)(getState());
    newMessage.shown = false;
    newMessage.timestamp = Date.now();
    var newConversation = [].concat(_toConsumableArray(conversation), [newMessage]);
    return dispatch({
      payload: newConversation,
      type: _types.CONVERSATION_SET
    });
  };
};

exports.conversationAppend = conversationAppend;

var conversationClear = function conversationClear() {
  return function (dispatch) {
    return dispatch({
      type: _types.CONVERSATION_CLEAR
    });
  };
};

exports.conversationClear = conversationClear;

var conversationRemoveLast = function conversationRemoveLast(messageType) {
  return function (dispatch) {
    return dispatch({
      payload: messageType,
      type: _types.CONVERSATION_REMOVE_LAST
    });
  };
};

exports.conversationRemoveLast = conversationRemoveLast;

var conversationSet = function conversationSet(conversation) {
  return function (dispatch) {
    return dispatch({
      payload: conversation,
      type: _types.CONVERSATION_SET
    });
  };
};

exports.conversationSet = conversationSet;

var conversationProcessingSet = function conversationProcessingSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.CONVERSATION_PROCESSING_SET
    });
  };
};

exports.conversationProcessingSet = conversationProcessingSet;

var conversationQueueAppend = function conversationQueueAppend(newMessage) {
  return function (dispatch, getState) {
    var queue = (0, _conversation.getConversationQueue)(getState());
    var newQueue = [].concat(_toConsumableArray(queue), [newMessage]);
    return dispatch({
      payload: newQueue,
      type: _types.CONVERSATION_QUEUE_SET
    });
  };
};

exports.conversationQueueAppend = conversationQueueAppend;

var conversationQueueClear = function conversationQueueClear() {
  return function (dispatch) {
    return dispatch({
      type: _types.CONVERSATION_QUEUE_CLEAR
    });
  };
};

exports.conversationQueueClear = conversationQueueClear;

var conversationQueueShift = function conversationQueueShift() {
  return function (dispatch, getState) {
    var queue = (0, _conversation.getConversationQueue)(getState());
    queue.shift();
    return dispatch({
      payload: queue,
      type: _types.CONVERSATION_QUEUE_SET
    });
  };
}; // eslint-disable-next-line max-statements


exports.conversationQueueShift = conversationQueueShift;

var processQueue = function processQueue() {
  return function _callee(dispatch, getState) {
    var _getState, _getState$conversatio, processing, queue, messages, i, message, messageText, messageTextLength, delays, delay;

    return regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), _getState$conversatio = _getState.conversation, processing = _getState$conversatio.processing, queue = _getState$conversatio.queue;

            if (processing) {
              _context.next = 32;
              break;
            }

            messages = queue[0];
            _context.next = 5;
            return regeneratorRuntime.awrap(dispatch(conversationQueueShift()));

          case 5:
            if (!messages) {
              _context.next = 32;
              break;
            }

            _context.next = 8;
            return regeneratorRuntime.awrap(dispatch(conversationProcessingSet(true)));

          case 8:
            i = 0;

          case 9:
            if (!(i < messages.length)) {
              _context.next = 28;
              break;
            }

            message = messages[i];

            if (!(message.type === _constants.CONVERSATION_TYPE_TEXT_BOT)) {
              _context.next = 21;
              break;
            }

            messageText = message.items[0];
            messageTextLength = messageText.length;
            delays = {
              "short": {
                length: 0,
                time: 2000
              },
              medium: {
                length: 50,
                time: 3000
              },
              "long": {
                length: 200,
                time: 4000
              }
            };
            delay = delays["short"].time;
            if (messageTextLength >= delays.medium.length && messageTextLength < delays["long"].length) delay = delays.medium.time;else if (messageTextLength >= delays["long"].length) delay = delays["long"].time;
            _context.next = 19;
            return regeneratorRuntime.awrap(dispatch((0, _app.appTypingSet)(true)));

          case 19:
            _context.next = 21;
            return regeneratorRuntime.awrap(wait(delay));

          case 21:
            _context.next = 23;
            return regeneratorRuntime.awrap(dispatch((0, _app.appTypingSet)(false)));

          case 23:
            _context.next = 25;
            return regeneratorRuntime.awrap(dispatch(conversationAppend(message)));

          case 25:
            i++;
            _context.next = 9;
            break;

          case 28:
            _context.next = 30;
            return regeneratorRuntime.awrap(dispatch(conversationProcessingSet(false)));

          case 30:
            _context.next = 32;
            return regeneratorRuntime.awrap(dispatch(processQueue()));

          case 32:
          case "end":
            return _context.stop();
        }
      }
    });
  };
};

exports.processQueue = processQueue;

var conversationSend = function conversationSend(utterance, event) {
  return function _callee2(dispatch, getState) {
    var _getState2, context;

    return regeneratorRuntime.async(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _getState2 = getState(), context = _getState2.app.context;

            if (!~utterance.indexOf('/', 0)) {
              _context2.next = 28;
              break;
            }

            _context2.t0 = utterance;
            _context2.next = _context2.t0 === _constants.SLASH_COMMAND_DEBUG ? 5 : _context2.t0 === _constants.SLASH_COMMAND_DEBUG_END ? 9 : _context2.t0 === _constants.SLASH_COMMAND_CHAT_END ? 13 : _context2.t0 === _constants.SLASH_COMMAND_CHAT_LEAVE_QUEUE ? 16 : _context2.t0 === _constants.SLASH_COMMAND_CHAT_RESET ? 19 : _context2.t0 === _constants.SLASH_COMMAND_SURVEY ? 24 : 27;
            break;

          case 5:
            console.info('Debug mode enabled.');
            _context2.next = 8;
            return regeneratorRuntime.awrap(dispatch((0, _app.appDebugSet)(true)));

          case 8:
            return _context2.abrupt("return", _context2.sent);

          case 9:
            console.info('Debug mode disabled.');
            _context2.next = 12;
            return regeneratorRuntime.awrap(dispatch((0, _app.appDebugSet)(false)));

          case 12:
            return _context2.abrupt("return", _context2.sent);

          case 13:
            _context2.next = 15;
            return regeneratorRuntime.awrap(_LiveEngage["default"].handleUserEndChat());

          case 15:
            return _context2.abrupt("return", _context2.sent);

          case 16:
            _context2.next = 18;
            return regeneratorRuntime.awrap(_LiveEngage["default"].handleUserLeaveChatQueue());

          case 18:
            return _context2.abrupt("return", _context2.sent);

          case 19:
            _context2.next = 21;
            return regeneratorRuntime.awrap(_LiveEngage["default"].reset());

          case 21:
            _context2.next = 23;
            return regeneratorRuntime.awrap(dispatch((0, _app.appContextReset)()));

          case 23:
            return _context2.abrupt("return", _context2.sent);

          case 24:
            _context2.next = 26;
            return regeneratorRuntime.awrap(_ChatbotsApi["default"].send('', _constants.EVENT_TYPE_RETURN_WELCOME));

          case 26:
            return _context2.abrupt("return", _context2.sent);

          case 27:
            return _context2.abrupt("break", 28);

          case 28:
            _context2.t1 = context;
            _context2.next = _context2.t1 === _constants.CONTEXT_LIVE_ENGAGE ? 31 : 34;
            break;

          case 31:
            _context2.next = 33;
            return regeneratorRuntime.awrap(_LiveEngage["default"].send(utterance));

          case 33:
            return _context2.abrupt("return", _context2.sent);

          case 34:
            return _context2.abrupt("break", 35);

          case 35:
            _context2.next = 37;
            return regeneratorRuntime.awrap(_ChatbotsApi["default"].send(utterance, event));

          case 37:
            return _context2.abrupt("return", _context2.sent);

          case 38:
          case "end":
            return _context2.stop();
        }
      }
    });
  };
};

exports.conversationSend = conversationSend;

var conversationInitialize = function conversationInitialize() {
  return function _callee3(dispatch, getState) {
    var _getState3, context;

    return regeneratorRuntime.async(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getState3 = getState(), context = _getState3.app.context;
            _context3.next = 3;
            return regeneratorRuntime.awrap(_ChatbotsApi["default"].init());

          case 3:
            _context3.next = 5;
            return regeneratorRuntime.awrap(dispatch((0, _app.appBlockedSet)(false)));

          case 5:
            if (context === _constants.CONTEXT_CHATBOTS_API) {
              dispatch((0, _traffic.trafficBotActionStart)());
            }

            if (!(0, _conversation.getConversationIsEmpty)(getState())) {
              _context3.next = 16;
              break;
            }

            if (!(context === _constants.CONTEXT_LIVE_ENGAGE)) {
              _context3.next = 14;
              break;
            }

            _context3.next = 10;
            return regeneratorRuntime.awrap(_LiveEngage["default"].handleUserEndChat());

          case 10:
            _context3.next = 12;
            return regeneratorRuntime.awrap(_LiveEngage["default"].reset());

          case 12:
            _context3.next = 14;
            return regeneratorRuntime.awrap(dispatch((0, _app.appContextReset)()));

          case 14:
            _context3.next = 16;
            return regeneratorRuntime.awrap(dispatch(conversationSend('', 'Welcome')));

          case 16:
            if (!(context === _constants.CONTEXT_LIVE_ENGAGE)) {
              _context3.next = 19;
              break;
            }

            _context3.next = 19;
            return regeneratorRuntime.awrap(_LiveEngage["default"].init());

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    });
  };
};

exports.conversationInitialize = conversationInitialize;